import axios from "axios"
import * as actions from "../actions/systemParameter"
import { FAQ_URL, HOME_PAGE_TEXT,LIST_OF_CANDIDATES_TEXT,INTRO_TEXT_CANDIDATE_DETAILS,STATE_GOVT_EMPLOYEE_LINK,
QUALIFICATIONS_HELPTEXT,SKILLS_EXPERTISE_HELPTEXT, CONTACT_US_PAGE_HTMLTEXT,DECLARATION_BODY_TEXT,FAQ_FOR_GENERAL_USERS,
FAQ_FOR_AUTHORISED_USERS,TITLE_HELPTEXT,LINKEDIN_LINK_HELPTEXT,ANY_COMMENTS_HELPTEXT,COMMUNICATIONS_HELPTEXT,GOOGLE_ANALYTICS_TRACKING_CODE
 } from '../js/const'

export function getSystemParameters() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter`)
      .then((response) => {
        let systemParameters = response && response.data ? response.data.$values : []
        dispatch(actions.getSystemParameters(systemParameters))
      })
  }
}

export function getHomePageText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${HOME_PAGE_TEXT}`)
      .then((response) => {
        let homePageText = response ? response.data : ''
        dispatch(actions.getHomePageText(homePageText))
      })
  }
}

export function getCandidateDetailsIntroText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${INTRO_TEXT_CANDIDATE_DETAILS}`)
      .then((response) => {
        let candidateDetailsIntroText = response ? response.data : ''
        dispatch(actions.getCandidateDetailsIntroText(candidateDetailsIntroText))
      })
  }
}

export function getStateGovtEmployeeLink() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${STATE_GOVT_EMPLOYEE_LINK}`)
      .then((response) => {
        let stateGovtEmployeeLink = response ? response.data : ''
        dispatch(actions.getStateGovtEmployeeLink(stateGovtEmployeeLink))
      })
  }
}

export function getQualificationsHelpText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${QUALIFICATIONS_HELPTEXT}`)
      .then((response) => {
        let qualificationsHelpText = response ? response.data : ''
        dispatch(actions.getQualificationsHelpText(qualificationsHelpText))
      })
  }
}

export function getContactUsPageHtmlText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${CONTACT_US_PAGE_HTMLTEXT}`)
      .then((response) => {
        let contactUsPageHtmlText = response ? response.data : ''
        dispatch(actions.getContactUsPageHtmlText(contactUsPageHtmlText))
      })
  }
}

export function getSkillsExpertiseHelpText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${SKILLS_EXPERTISE_HELPTEXT}`)
      .then((response) => {
        let skillsExpertiseHelpText = response ? response.data : ''
        dispatch(actions.getSkillsExpertiseHelpText(skillsExpertiseHelpText))
      })
  }
}

export function getCommunicationsHelpText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${COMMUNICATIONS_HELPTEXT}`)
      .then((response) => {
        let communicationsHelpText = response ? response.data : ''
        dispatch(actions.getCommunicationsHelpText(communicationsHelpText))
      })
  }
}

export function getDeclarationBodyText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${DECLARATION_BODY_TEXT}`)
      .then((response) => {
        let declarationBodyText = response ? response.data : ''
        dispatch(actions.getDeclarationBodyText(declarationBodyText))
      })
  }
}

export function getFaqForGeneralUsersHelpText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${FAQ_FOR_GENERAL_USERS}`)
      .then((response) => {
        let faqForGeneralUsersHelpText = response ? response.data : ''
        dispatch(actions.getFaqForGeneralUsersHelpText(faqForGeneralUsersHelpText))
      })
  }
}

export function getFaqForAuthorisedUsers() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${FAQ_FOR_AUTHORISED_USERS}`)
      .then((response) => {
        let faqForAuthorisedUsers = response ? response.data : ''
        dispatch(actions.getFaqForAuthorisedUsers(faqForAuthorisedUsers))
      })
  }
}

export function getTitleHelpText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${TITLE_HELPTEXT}`)
      .then((response) => {
        let titleHelpText = response ? response.data : ''
        dispatch(actions.getTitleHelpText(titleHelpText))
      })
  }
}

export function getLinkedInLinkHelpText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${LINKEDIN_LINK_HELPTEXT}`)
      .then((response) => {
        let linkedInLinkHelpText = response ? response.data : ''
        dispatch(actions.getLinkedInLinkHelpText(linkedInLinkHelpText))
      })
  }
}

export function getAnyCommentsHelpText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${ANY_COMMENTS_HELPTEXT}`)
      .then((response) => {
        let anyCommentsHelpText = response ? response.data : ''
        dispatch(actions.getAnyCommentsHelpText(anyCommentsHelpText))
      })
  }
}



export function getListOfCandidatesText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${LIST_OF_CANDIDATES_TEXT}`)
      .then((response) => {
        let listOfCandidatesText = response ? response.data : ''
        dispatch(actions.getListOfCandidatesText(listOfCandidatesText))
      })
  }
}

export function getFaqUrl() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${FAQ_URL}`)
      .then((response) => {
        let faqUrl = response ? response.data : ''
        dispatch(actions.getFaqUrl(faqUrl))
      })
  }
}

export function getGoogleAnalyticsTrackingCode() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${GOOGLE_ANALYTICS_TRACKING_CODE}`)
      .then((response) => {
        let googleAnalyticsTrackingCode = response ? response.data : ''
        dispatch(actions.getGoogleAnalyticsTrackingCode(googleAnalyticsTrackingCode))
      })
  }
}

export function updateSystemParameter(systemParameter) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/system-parameter`, systemParameter)
        .then(response => {
          if (response && response.data.Success) {
            dispatch(actions.getSystemParameters(response.data.SuccessOutput.$values))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/systemParameter.js